export const mustBeDefined = <T>(value: T | undefined) => {
  if (value !== undefined) {
    return value;
  } else {
    throw new Error("Required variable was undefined!");
  }
};
